import React from 'react';

const useMultiFirebaseDatabaseQuery = (refs = []) => {
  const [docState, setDocState] = React.useState({
    isLoading: true,
    data: null,
  });

  React.useEffect(() => {
    const tempData = [];
    Promise.all(refs.map((ref, index) => new Promise((resolve) => {
      ref.on('value', (snapshot) => {
        tempData[index] = snapshot?.val() || {};
        resolve();
      });
    }))).then(() => setDocState({
      isLoading: false,
      data: tempData,
    }));
  }, []); //eslint-disable-line

  return docState;
};

export default useMultiFirebaseDatabaseQuery;
